"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatBase = void 0;
var react_1 = require("@headlessui/react");
var solid_1 = require("@heroicons/react/24/solid");
var outline_1 = require("@heroicons/react/24/outline");
var moment_1 = __importDefault(require("moment"));
var react_2 = __importStar(require("react"));
require("../../../index.css");
var iconButton_1 = require("../../action/iconButton");
var form_1 = require("../../input/form");
var textInput_1 = require("../../input/textInput");
var ChatBase = /** @class */ (function (_super) {
    __extends(ChatBase, _super);
    function ChatBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            searchBoxVisible: false,
            scrolling: false,
        };
        _this.timeout = null;
        _this.scrollToBottomRef = (0, react_2.createRef)();
        _this.actions = [
            {
                text: "Search",
                onClick: function () {
                    _this.setState({ searchBoxVisible: true });
                },
                icon: react_2.default.createElement(solid_1.MagnifyingGlassIcon, { className: "w-3 h-3", "aria-hidden": "true" }),
            },
        ];
        _this.componentDidUpdate = function (prevProps) {
            var _a;
            if (prevProps.conversation.messageList.length !==
                _this.props.conversation.messageList.length &&
                !_this.state.scrolling) {
                (_a = _this.scrollToBottomRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                });
            }
        };
        _this.handleOnSearch = function (searchMessage) {
            var _a, _b;
            (_b = (_a = _this.props).onSearch) === null || _b === void 0 ? void 0 : _b.call(_a, searchMessage);
        };
        _this.handleOnChangeMessage = function (e) {
            var _a, _b;
            (_b = (_a = _this.props).onChangeMessage) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        };
        _this.handleOnChangeSearch = function (e) {
            var _a, _b;
            (_b = (_a = _this.props).onChangeSearch) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        };
        _this.handleConversationScroll = function () {
            if (_this.timeout)
                clearTimeout(_this.timeout);
            _this.setState({ scrolling: true });
            _this.timeout = setTimeout(function () {
                _this.setState({ scrolling: false });
            }, 500);
        };
        _this.handleOnSendMessage = function () {
            if (_this.props.onSendMessage && _this.props.value.length > 0) {
                var dupConversation = {
                    id: _this.props.conversation.id,
                    members: __spreadArray([], _this.props.conversation.members, true),
                    messageList: __spreadArray([], _this.props.conversation.messageList, true),
                };
                dupConversation.messageList.push({
                    sender: _this.props.currentUser,
                    messageBody: _this.props.value,
                    createdAt: (0, moment_1.default)().toDate(),
                });
                _this.props.onSendMessage(dupConversation);
            }
        };
        _this.renderDefaultHeader = function () {
            return (react_2.default.createElement("div", { className: "flex flex-col justify-center h-12 pl-6 text-white bg-primary-500" },
                react_2.default.createElement("p", null, "Chat")));
        };
        _this.renderConversation = function () {
            var _a;
            return (react_2.default.createElement("div", { onScroll: _this.handleConversationScroll, className: "chat-scrollbar w-full h-full overflow-y-auto" },
                _this.state.searchBoxVisible && _this.renderSearch(),
                react_2.default.createElement("div", { className: "w-full h-fit flex flex-col p-2 space-y-2" }, (_a = _this.props.bodyElement) !== null && _a !== void 0 ? _a : _this.renderMessages(),
                    react_2.default.createElement("div", { ref: _this.scrollToBottomRef }))));
        };
        _this.renderMessages = function () {
            var renderedMessages = [];
            _this.props.conversation.messageList.map(function (eachMessage) {
                var sent = eachMessage.sender.id === _this.props.currentUser.id;
                var defaultRoundedNone = sent ? "rounded-tr-none" : "rounded-tl-none";
                var defaultBgColor = sent ? "bg-primary-500" : "bg-gray-100";
                var defaultTextColor = sent ? "text-white" : "text-black";
                var defaultClassName = "p-2 ".concat(defaultBgColor, " rounded-md ").concat(defaultRoundedNone, " ").concat(defaultTextColor, " text-xs flex-col");
                if (sent) {
                    renderedMessages.push(react_2.default.createElement("div", { className: "max-w-[75%] ml-auto" },
                        react_2.default.createElement("div", { className: defaultClassName },
                            react_2.default.createElement("p", { className: "whitespace-pre-line" }, eachMessage.messageBody),
                            react_2.default.createElement("span", { className: "mt-1 flex justify-end text-[9px] text-gray-200" }, (0, moment_1.default)(eachMessage.createdAt).format("MMM DD HH:mm")))));
                }
                else {
                    renderedMessages.push(react_2.default.createElement("div", { className: "max-w-[75%] flex mr-auto space-x-2" },
                        eachMessage.sender.imageUrl ? (react_2.default.createElement("img", { src: eachMessage.sender.imageUrl, alt: "", className: "w-8 h-8 rounded-full" })) : (react_2.default.createElement("div", { className: "flex flex-col items-center justify-center w-8 h-8 rounded-full bg-primary-500 " },
                            react_2.default.createElement(solid_1.ChatBubbleOvalLeftIcon, { color: "white", className: "w-8 h-5" }))),
                        react_2.default.createElement("div", { className: "flex flex-col space-y-0.5" },
                            react_2.default.createElement("p", { className: "text-xs text-gray-500" }, eachMessage.sender.name),
                            react_2.default.createElement("div", { className: defaultClassName },
                                react_2.default.createElement("p", { className: "whitespace-pre-line" }, eachMessage.messageBody),
                                react_2.default.createElement("span", { className: "mt-1 flex justify-end text-[9px] text-gray-500" }, (0, moment_1.default)(eachMessage.createdAt).format("MMM DD HH:mm"))))));
                }
                return null;
            });
            return renderedMessages;
        };
        _this.renderActions = function () {
            return (react_2.default.createElement("div", { className: "absolute text-right top-2 right-2" },
                react_2.default.createElement(react_1.Menu, { as: "div", className: "relative text-left" },
                    react_2.default.createElement("div", null,
                        react_2.default.createElement(react_1.Menu.Button, { className: "w-full p-2 bg-white rounded-md hover:bg-gray-100 text-primary-500" },
                            react_2.default.createElement(solid_1.EllipsisVerticalIcon, { className: "w-4 h-4 ", "aria-hidden": "true" }))),
                    react_2.default.createElement(react_1.Transition, { as: react_2.Fragment, enter: "transition ease-out duration-100", enterFrom: "transform opacity-0 scale-95", enterTo: "transform opacity-100 scale-100", leave: "transition ease-in duration-75", leaveFrom: "transform opacity-100 scale-100", leaveTo: "transform opacity-0 scale-95" },
                        react_2.default.createElement(react_1.Menu.Items, { className: "absolute right-0 z-20 mt-1 text-xs origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-md w-max" }, _this.renderActionItem())))));
        };
        _this.renderActionItem = function () {
            var actionItemList = [];
            var availableActions = _this.actions;
            if (_this.props.additionalAction)
                availableActions = availableActions.concat(_this.props.additionalAction);
            availableActions.map(function (eachAction) {
                return actionItemList.push(react_2.default.createElement(react_1.Menu.Item, null,
                    react_2.default.createElement("button", { onClick: eachAction.onClick, className: "flex w-full items-center rounded-md p-3 gap-1 hover:bg-gray-100" },
                        eachAction.icon,
                        eachAction.text)));
            });
            return actionItemList;
        };
        _this.renderSearch = function () {
            return (react_2.default.createElement("div", { className: "z-10 sticky top-0 left-0 flex p-2 space-x-2 bg-white justify-center items-center" },
                react_2.default.createElement(form_1.Form, { refList: [], handleComplete: function () { var _a; return _this.handleOnSearch((_a = _this.props.searchMessage) !== null && _a !== void 0 ? _a : ""); }, className: "w-full flex" },
                    react_2.default.createElement(textInput_1.TextInput, { type: "text", value: _this.props.searchMessage, label: "", onChange: function (e) { return _this.handleOnChangeSearch(e); }, placeholder: "Search messages in chat", inputClassName: "text-xs shadow-md placeholder:text-gray-400", containerClassName: "w-full" })),
                react_2.default.createElement(iconButton_1.IconButton, { onClick: function () { var _a; return _this.handleOnSearch((_a = _this.props.searchMessage) !== null && _a !== void 0 ? _a : ""); }, icon: react_2.default.createElement(solid_1.MagnifyingGlassIcon, { className: "w-5 h-5" }), className: "focus:ring-transparent flex flex-col justify-center" }),
                react_2.default.createElement(iconButton_1.IconButton, { onClick: function () {
                        _this.handleOnSearch("");
                        _this.setState({ searchBoxVisible: false });
                    }, className: "focus:ring-transparent flex flex-col justify-center", icon: react_2.default.createElement(solid_1.XMarkIcon, { className: "w-5 h-5", color: "red" }) })));
        };
        _this.renderLoadingReply = function () {
            var defaultClassName = "w-2 h-2 bg-primary-500 rounded-full";
            return (react_2.default.createElement("div", { className: "flex px-2 py-1 space-x-1" },
                react_2.default.createElement("span", { className: "".concat(defaultClassName, " firstLoadingDot") }),
                react_2.default.createElement("span", { className: "".concat(defaultClassName, " secondLoadingDot") }),
                react_2.default.createElement("span", { className: "".concat(defaultClassName, " thirdLoadingDot") })));
        };
        return _this;
    }
    ChatBase.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var defaultClassName = "relative ".concat((_a = this.props.sizeClassName) !== null && _a !== void 0 ? _a : "h-[75vh]", " flex flex-col justify-between bg-white rounded-md");
        var disableMessageInput = this.props.disableMessageInput || this.props.isLoadingReply;
        return (react_2.default.createElement("div", { className: "".concat(defaultClassName, " ").concat(this.props.className) },
            react_2.default.createElement("div", { className: "relative w-full h-fit border-b border-gray-300" }, (_b = this.props.headerElement) !== null && _b !== void 0 ? _b : this.renderDefaultHeader(),
                this.renderActions()),
            this.props.bodyElement
                ? this.props.bodyElement
                : this.props.conversation
                    ? this.renderConversation()
                    : null,
            this.props.footerElement,
            react_2.default.createElement("div", { className: "flex justify-between p-2 space-x-2" },
                react_2.default.createElement(form_1.Form, { refList: [], className: "w-full", handleComplete: this.handleOnSendMessage },
                    this.props.isLoadingReply && this.renderLoadingReply(),
                    react_2.default.createElement(textInput_1.TextInput, { type: "text", value: this.props.value, placeholder: "Ask a question", label: "", onChange: function (e) {
                            _this.handleOnChangeMessage(e);
                        }, disabled: disableMessageInput, inputClassName: "text-xs placeholder:text-gray-400" })),
                this.props.value.length > 0 && (react_2.default.createElement(iconButton_1.IconButton, { onClick: this.handleOnSendMessage, className: "flex flex-col justify-center", icon: react_2.default.createElement(outline_1.PaperAirplaneIcon, { className: "w-5 h-5 text-primary-500" }) })))));
    };
    return ChatBase;
}(react_2.Component));
exports.ChatBase = ChatBase;
//# sourceMappingURL=index.js.map